import type { RecommendationCardProps } from "./recommendation-card.type";

import { Card } from "antd";
import classNames from "classnames";
import { useState } from "react";

import RecommendationCardContent from "./recommendation-card-content";
import RecommendationCardExtra from "./recommendation-card-extra";
import RecommendationCardTitle from "./recommendation-card-title";

import "./recommendation-card.style.less";

const RecommendationCard = ({
  interventionAsset,
  intervention,
  observation,
  loading,
  disabled,
  className,
  ...cardProps
}: RecommendationCardProps) => {
  const [hover, setHover] = useState<boolean>(false);

  return (
    <Card
      {...cardProps}
      classNames={{
        root: classNames("recommendation-card", className),
        header: "recommendation-card--header",
        title: "recommendation-card--title",
        extra: "recommendation-card--extra",
        body: "recommendation-card--body",
      }}
      loading={loading}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      title={
        <RecommendationCardTitle
          interventionId={intervention.id}
          observation={observation}
          disabled={disabled || loading}
          loading={loading}
          hover={hover}
        />
      }
      extra={
        <RecommendationCardExtra
          interventionId={intervention.id}
          observation={observation}
          disabled={disabled || loading}
        />
      }
    >
      <RecommendationCardContent
        interventionAsset={interventionAsset}
        intervention={intervention}
        observation={observation}
        disabled={disabled || loading}
      />
    </Card>
  );
};

export default RecommendationCard;
